import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  background-color: #161515;

  @media (max-width: 1023px) {
    padding: 40px 24px;
  }

  @media (min-width: 1024px) {
    padding: 64px 80px 40px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  max-width: 1280px;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1760px;

  @media (max-width: 1023px) {
    flex-direction: column;
    row-gap: 40px;
  }

  @media (min-width: 1024px) {
    column-gap: 120px;
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1023px) {
    flex-direction: column;
    row-gap: 40px;
  }

  @media (min-width: 1024px) {
    justify-content: space-between;
    column-gap: 40px;
  }
`;

export const Logo = styled.a`
  width: 100%;

  @media (max-width: 1023px) {
    max-width: 120px;
  }

  @media (min-width: 1024px) {
    max-width: 165px;
  }
`;

export const Body = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 800px;

  @media (max-width: 1023px) {
    flex-direction: column;
    align-items: center;
    row-gap: 56px;
    text-align: center;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

export const Title = styled.div`
  color: #fff;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
`;

export const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const NavLink = styled.a`
  padding: 0;
  color: #c3c3c3;
  font-size: 11px;
  line-height: 18px;
  letter-spacing: 0.22px;
  text-decoration: none;

  @media (max-width: 1023px) {
    text-align: center;
  }

  &:hover {
    color: #fff;
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;

export const SocialLink = styled.a`
  width: 32px;
  height: 32px;
  color: #fff;
  font-size: 32px;
`;

export const Legal = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  width: 100%;
  max-width: 1280px;
  color: #c3c3c3;
  font-size: 11px;
  font-weight: 325;
  line-height: 18px;
  letter-spacing: 0.22px;

  @media (max-width: 1023px) {
    text-align: center;
  }

  a {
    color: inherit;
    text-decoration-line: underline;
  }
  p {
    margin: 0;
  }
`;

export const ToTopButton = styled(ScrollLink)`
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  background-color: #222;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23ffffff' d='M 1.645 11.323 L 7 5.979 L 12.355 11.323 L 14 9.678 L 7 2.678 L 0 9.678 L 1.645 11.323 Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
  border-radius: 25px;
  cursor: pointer;
`;
